export const getAdminAvailableCompanies = state => state.api.companyAdmin.company.companies;
export const getAdminSelectedCompanyId = state => state.api.companyAdmin.company.companyId;
